import styled, { css } from "styled-components";
import { Colors, CommonLabel, FlexBox, GridBox, MEDIA } from '@brg/ui';
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { LayoutConst } from 'core';
import { ProjectEditPageGrid, ProjectEditPageGridLabel } from "shared/components/ProjectEditPageGrid";
import { EMBLEM_DESKTOP_SIZE, EMBLEM_TABLET_TABLET_SIZE, EMBLEM_MOBILE_SIZE, EMBLEM_LAPTOP_TABLET_SIZE } from "./const/emblemSizes";

export const CommonContainer = styled(ProjectEditPageGrid)<{ fullWidth?: boolean }>`
    max-width: ${({ fullWidth }) => fullWidth ? '1152px' : '804px'};
`;

export const ActionsButton = styled(FlexBox)`
    font-size: 11px;
    line-height: 13px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
    width: 107px;
    text-align: center;
    margin: 0 auto;
`;


export const TeamsWrapper = styled(FlexBox)`
    width: 100%;
    flex-flow: column;
    padding-top: 40px;
`;
export const TeamUploadText = styled.span`
    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 14px;
    }
`;

export const GridItem = styled(FlexBox)`
    min-width: 127px;
    min-height: 30px;
    max-width: 244px;
    border: 1px solid #909090;
    border-radius: 5px;
    place-items: center;
    justify-content: flex-start;
    position: relative;
    font-size: 15px;
    line-height: 20px;
    padding: 4px 15px 4px 16px;
    overflow: hidden;

    color: ${({ theme }) => theme.gridItem.color};

    .item-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0;
        max-width: calc(100% - 24px);
    }

    svg {
        margin-left: 8px;
        cursor: pointer;
        flex-shrink: 0;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px){
        min-width: 118px;
        min-height: 26px;
        font-size: 13px;
        line-height: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s-1}px){
        min-width: 110px;
        min-height: 26px;
    }
`;

export const Since = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    color: ${({ theme}) => theme.teamsPage.text.label.color};
`;

export const OwnerNamePrefix = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 32px;

    color: ${({ theme}) => theme.teamsPage.text.label.color};

`;

export const OwnerName = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 32px;
    color: ${({ theme}) => theme.teamsPage.text.color};
`;


export const AvatarWrapper = styled(FlexBox)`
    max-width: 270px;
    width: 270px;
    max-height: 183px;
`;

export const InfoWrapper = styled(FlexBox)`
    flex-flow: row;
    justify-content: space-between;
    place-items: start;
    width: calc(100% - 270px - 32px);
`;

export const ContentWrapper = styled(FlexBox)`
`;

export const LocationWrapper = styled(FlexBox)`
    height: 384px;
    max-heigt: 384px;
    width: 100%;
`;

export const DropdownWrapper = styled(FlexBox)`
    justify-content: flex-start;

    .dropdown-header {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 43px;
        line-height: 51px;
        letter-spacing: -0.02em;
        color: ${({ theme}) => theme.teamsPage.dropdown.text.color};
    }
`;

export const DescriptionWrapper = styled(FlexBox)`
    max-width: 688px;

    textarea {
        min-height: 163px !important;
        width: 688px;
        max-width: 688px;
        border: none;
        &::placeholder {
            color: ${p => p?.theme?.teamsPage.input.color};
        }
        &:hover {
            &::placeholder {
                color: ${p => p?.theme?.teamsPage.input.color};
            }
        }
    }
`;

export const TagsWrapper = styled(FlexBox)`
    max-width: 564px;
`;


export const PointLogoContainer = styled(FlexBox)`
    flex-flow: row;
`;

export const PointCity = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${({ theme}) => theme.teamsPage.text.color};
`;

export const PointText = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    margin: 0 8px 0 10.5px;
    color: ${({ theme}) => theme.teamsPage.text.point.color};
`;

export const TeamContextInputWrapper = styled(FlexBox)`
    // max-width: 600px !important;
    // width: 600px !important;
    width: 100%;
    flex-flow: row;

    .item-wrapper {
        margin: 0 8px 8px 0;
    }

    button {
        margin-left: 16px;
    }
    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 520px !important;
        width: 520px !important;
        
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
        width: 100% !important;
        max-width: 100% !important;
        
    }
`;

export const TeamContextListWrapper = styled(FlexBox)`
    max-width: 400px !important;
    width: 400px !important;
    flex-wrap: wrap;

    @media(max-width: ${LayoutConst.screen.s}px) {
        width: 100% !important;
        max-width: none !important;
    }
`;

export const TableSortWrapper = styled(FlexBox)<{backgroundColor?: string}>`

    .not-allowed-text {
        position: absolute;
        bottom: -15px;
        width: 100%;
        left: 32px;
        color: red;
        font-size: 9px;
        line-height: 11px;
    }
    position: relative;
    svg {
        margin-right: 8px;
    }

    input {
        // width: 394px;
        margin-right: 8px;
        background: ${({backgroundColor}) => backgroundColor ? backgroundColor + ' !important' : 'transparent'};
        &:disabled {
            color: ${({backgroundColor}) => backgroundColor ? '#ffffff !important' : '#909090'};
        }
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        input {
            width: 312px;
             margin-right: 0;
        }
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        input {
            width: 100%;
            min-width: 156px;
        }
    }
`;

export const TBody = styled.tbody<{ isFormEdit?: boolean }>`
    tr {
        width: ${({ isFormEdit }) => isFormEdit ? '185px' : '195px'};
        max-width: ${({ isFormEdit }) => isFormEdit ? '185px' : '195px'};

        ${ActionsButton} {
            width: 195px !important;
        }

        .brg-input__control {
            height: 48px !important;
        }

        td:first-child {
            padding-left: 0 !important;

            .brg-input__control {
                width: 195px !important;
            }
        }
    }

    .ui-input_container {
        width: 185px;
    }

    .anchor-info {
        width: ${({ isFormEdit }) => isFormEdit ? '185px' : '180px'} !important;
        text-align: center !important;
    }

    .brg-input__control {
        width: ${({ isFormEdit }) => isFormEdit ? '185px' : '195px'} !important;
        background-color: ${({ theme }) => theme.commonInput?.bg ?? '#f2f2f2'} !important;
        color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
        border: 0px solid transparent !important;
    }
    .brg-input__menu {
        background-color: ${({ theme }) => theme.commonInput?.bg ?? '#f2f2f2'} !important;
        * {
        color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
        background-color: transparent !important;
        cursor: pointer;
        }
    }
    .brg-input__single-value {
        color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
    }
    .brg-input__indicator {
        svg path {
            fill: ${({ theme }) => theme.commonInput?.icons?.color ?? '#909090'} !important;
        }
    }
`;
export const TBodyAdvertisements = styled.tbody`
    tr {
        .brg-input__control {
            height: 48px !important;
        }

        td:first-child {
            padding-left: 0 !important;

            .brg-input__control {
                width: 195px !important;
            }
        }
    }
`;

export const TeamsMobGridList = styled(GridBox)<{isTeamEditButtons?: boolean}>`
    gap: 16px;

    // input {
    //     max-width: 306.5px !important;
    //     height: 40px !important;
    //     @media(max-width: ${LayoutConst.screen.md}px){
    //         width: ${({isTeamEditButtons}) => isTeamEditButtons ? '260px' : '100%'} !important;
    //         max-width: 100% !important;
    //     }
    // }

${ProjectEditPageGridInput} {
    width: 306px !important;
    max-width: 306px !important;
    @media(max-width: ${LayoutConst.screen.md}px){
        width: ${({isTeamEditButtons}) => isTeamEditButtons ? 260 : 306}px !important;
    }

}

.brg-input__control {
    width: 306.5px !important;
    background-color: ${({ theme }) => theme.commonInput?.bg ?? '#f2f2f2'} !important;
    color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
    border: 0px solid transparent !important;
    height: 40px !important;
     @media(max-width: ${LayoutConst.screen.md}px){
            width: ${({isTeamEditButtons}) => isTeamEditButtons ? '260px' : '100%'} !important;
        }
}
.brg-input__menu {
    background-color: ${({ theme }) => theme.commonInput?.bg ?? '#f2f2f2'} !important;
    * {
    color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
    background-color: transparent !important;
    cursor: pointer;
    }
}
.brg-input__single-value {
    color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
}
.brg-input__indicator {
    svg path {
        fill: ${({ theme }) => theme.commonInput?.icons?.color ?? '#909090'} !important;
    }
}

@media(max-width: ${LayoutConst.screen.s}px) {
    grid-template-columns: 1fr !important;
    margin-left: 0 !important;

    ${ProjectEditPageGridInput} {
        width: 100% !important;
        max-width: 100% !important;
    }

    // input {
    //     max-width: 100% !important;
    //     height: 40px !important;
    //     background-color: #E7E7E7 !important;
    // }

    .brg-input__control {
        width: 100% !important;
        background-color: #E7E7E7 !important;
        color: #909090 !important;
        border: 0px solid transparent !important;
        height: 40px !important;
    }
}

`;

export const GridMobileNamed = styled(FlexBox)`
    flex-flow: row;
    width: 100%;
    place-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    span {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: #909090;
        margin-right: 24px;
        white-space: nowrap;
    }

    
    button {
        font-size: 13px !important;
        line-height: 16px !important;
    }
`;

export const TeamLgInputsWrapper = styled(FlexBox)<{ fs?: boolean, hide?: boolean }>`
    margin: ${({ fs }) => fs ? '0 auto 32px auto': '0 auto'};
    justify-content: flex-start;
    max-width: 1152px;
    width: 1152px;
    display: ${({ hide }) => hide ? 'none' : 'flex'};
`;

export const ColorWrapper = styled(FlexBox)`
    width: 602px;
`;

export const PlusButton = styled(FlexBox)`
    border-radius: 5px;
    border: 1px solid ${Colors.galBlack47};
    width: 48px;
    height: 30px;
    cursor: pointer;
    justify-content: center;
    place-items: center;
`;

export const InlinePlusButton = styled(PlusButton)`
    display: inline-block;
    text-align: center;
    vertical-align: middle;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 26px;
        width: 42px;
        svg {
            width: 12px;
            height: 12px;
        }
    }
`;

export const DefaultButton = styled.button<{ wh?: number, whMob?: number, whDes?: number, isTablet?: boolean, hollow?: boolean, isCompetitionEdit?: boolean, hasLongread?: boolean }>`
    display: flex;
    place-items: center;
    justify-content: center;
    height: 48px;
    border: 1px solid rgba(182, 182, 181, 1) !important;
    color: ${({ theme, hollow }) => hollow ? theme.competition.input.secondText : 'rgba(21, 21, 20, 1)'} !important;
    font-size: ${({ isCompetitionEdit }) => isCompetitionEdit ? '17px' : '15px'};
    font-family: 'Inter';
    line-height: ${({ isCompetitionEdit }) => isCompetitionEdit ? '22px' : '20px'};
    outline: none;
    cursor: pointer !important;
    border-radius: 3px;
    font-weight: ${({hasLongread}) => hasLongread ? 400 : 600};
    background-color: ${({ hollow }) => hollow ? 'transparent' : 'rgba(254, 254, 254, 1)'} !important;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        ${({ isCompetitionEdit }) => isCompetitionEdit && css`
            font-size: 15px;
            line-height: 20px;
        `};
        height: 40px;
        font-weight: 400;
    }

    &:disabled {
        pointer-events: none;
        background-color: transparent !important;
        cursor: not-allowed;
        color: grey !important;
        border: none;
    }

    svg {
        margin-right: 12px;

        path {
            fill: ${({ theme, hollow }) => hollow ? theme.competition.input.secondText : 'rgba(84, 84, 83, 1)'};
        }
    }

    ${({ wh }) => wh ? css`
        max-width: ${wh}px !important;
        width: ${wh}px !important;
        min-width: ${wh}px !important;
        background-color: rgba(254, 254, 254, 1);
    ` : null};

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        ${({ whDes }) => whDes ? css`
        max-width: ${whDes}px !important;
        width: ${whDes}px !important;
        min-width: ${whDes}px !important;
        background-color: rgba(254, 254, 254, 1);
    ` : null};
    }
    @media(max-width: ${LayoutConst.screen.md}px) {
        ${({ whMob }) => whMob ? css`
        max-width: ${whMob}px !important;
        width: ${whMob}px !important;
        min-width: ${whMob}px !important;
        background-color: rgba(254, 254, 254, 1);
    ` : null};
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: 100% !important;
        width: 100% !important;
        min-width: auto !important;
        background-color: rgba(254, 254, 254, 1);
    }
`;

export const UploaderWrapper = styled(FlexBox)<{ isUploaded?: boolean }>`
    max-width: 600px;
    width: 100%;
    position: relative;
    cursor: ${({ isUploaded }) => isUploaded ? 'default' : 'pointer'};

    .download-link {
        font-family: 'Inter';
        color: #151514 !important;
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        cursor: default !important;
    }

    a {
        color: #151514 !important;
        text-decoration: underline;
        cursor: pointer;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const MobileButtonsWrapper = styled(FlexBox)<{disabled?: boolean}>`

    @media(max-width: ${LayoutConst.screen.s}px) {
        background-color: #F2F2F2;
        border-radius: 3px;
        flex-flow: column;
        padding: 16px 10px;

        button {
            font-size: 13px !important;
            line-height: 16px !important;
        }
        ${({ disabled }) =>
            disabled && css`
            pointer-events: none;
            opacity: 0.6;
        `}
    }
`;

export const CoverWrapper = styled(FlexBox)`
    svg {
        &:hover {
            cursor: pointer;
        }
    }

    input[type='file'] {
        ::-webkit-file-upload-button { 
            cursor:pointer;
        }
        cursor: pointer;
        font-size: 0;
        position: absolute;
    }
`;

export const MainHeader = styled.h1`
    font-family: 'Inter';
    font-weight: 600;
    font-size: 60px;
    line-height: 70px;
    white-space: nowrap;
    // color: #151514;
    margin: 0;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 34px;
        line-height: 41px;
    }
    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 28px;
        line-height: 34px;
        white-space: pre;
    }
`;

export const ChannelMainHeader = styled(MainHeader)`
    font-size: 34px;
    line-height: 41px;
`;

export const ChannelDescription  = styled.div`
    font-family: 'Inter';
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #909090;
    margin: 0;
    max-width: 802px;

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

export const OuterDescription = styled(ChannelDescription)<{darkText?: boolean }>`
    color: ${({ darkText }) => darkText ? Colors.galBlack100 : Colors.galBlack47};

    a {
    text-decoration: underline;
    }
`

export const SuccessMsg = styled.div`
    font-family: 'Inter';
    font-weight: 600;
    font-size: 34px;
    line-height: 41px;
    color: #151514;
    margin-top: 15px;
    max-width: 700px;
    text-align: center;

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        white-space: pre-wrap;
        font-size: 20px;
        line-height: 32px;
    }
`;

export const MainTabsWrapper = styled(FlexBox)`
    flex-flow: row;

    .white_theme_project_underline {
        font-size: 23px;
        line-height: 29px;
        margin-right: 40px;

        @media(max-width: ${LayoutConst.screen.m}px) {
            font-size: 17px;
            line-height: 22px;
            margin-right: 24px;
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 13px;
            line-height: 18px;
        }
    }
`;

export const MainFilterContainer = styled(CommonContainer)<{isShopTagsOnly?: boolean}>`
    .checkbox {
        padding-bottom: 0;
        padding-top: 0;
    }
     @media(max-width: ${LayoutConst.screen.md}px) {
        margin: ${({isShopTagsOnly}) => isShopTagsOnly ? '15px 0px' : '15px 20px'};
     }    
     @media(max-width: ${LayoutConst.screen.s}px) {
        margin: 0 auto;
        margin-top: 24px;
     }    
`;

export const LangBlockWrapper = styled(FlexBox)<{ maxSize?: number }>`
    // flex-flow: row;
    align-items: start;
    max-width: ${({ maxSize }) => maxSize ? maxSize : 802}px;
    // margin-top: 40px;
    width: 100%;

    input, textarea {
        margin: 0;
    }

    .styled-input {
        width:100% !important;
    }

    th {
        padding-top: 0 !important;
    }

    .lang-label-block {
        margin-right: 32px !important;
        width: 180px;
        min-width: 180px;
        justify-content: space-between;
        .lang-label {
            width: auto;
        }

        h6 {
            font-size: 17px;
            line-height: 22px;
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px){
            width: 100%;
            min-width: 100%;
        }
    }
    @media(max-width: ${LayoutConst.screen.m}px){
        max-width: 720px;
    }
`;

export const LangBlockWrapperWithInfoMargin = styled(LangBlockWrapper)`
    .info-icon-wrapper {
        margin-right: 0;
    }
`;


export const TeamEditLabel = styled(ProjectEditPageGridLabel)<{ required?: boolean, nowrap?: boolean, fullWidth?: boolean}>`
    width: ${({ fullWidth }) => fullWidth ? '100%' : '180px'};
    min-width: ${({ fullWidth }) => fullWidth ? '100%' : '180px'};
    max-width: ${({ fullWidth }) => fullWidth ? '100%' : '180px'};
    margin-right: 32px;
    // align-items: flex-start;
    padding-top: 0;

    font-size: 15px;
    line-height: 20px;
    position: relative;

    ${({ required }) => required && css`
        &::after {
            position: absolute;
            top: 3px;
            right: -8px;
            content: '*';
            display: contents;
            color: #C64839;
        }
    }
    `};

    .required-label {
        &::after {
            position: absolute;
            top: 50%;
            left: 10%;
            transform: translateY(-50%);
            display: contents;
            content: '*';
            color: #C64839;
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        width: ${({ fullWidth }) => fullWidth ? '100%' : '180px'};
        min-width: ${({ fullWidth }) => fullWidth ? '100%' : '180px'};
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        white-space: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'}!important;
    }

    @media(max-width: ${LayoutConst.screen.s-1}px) {
        width: 100%;
        max-width: none;
        white-space: pre-wrap !important;
        font-size: 15px;
        line-height: 20px;
        .required-label {
            position: relative;
            &::after {
                position: absolute;
                top: 50%;
                left: 102%;
                display: inline;
                content: '*';
            }
    }
    }
`;

export const AdminHeader = styled(FlexBox)`
    flex-flow: column;
    gap: 32px;
    margin-bottom: 32px;

    @media(max-width: ${LayoutConst.screen.m_1024}px) {
        margin: 0 10px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        max-width: ${LayoutConst.container.tablet}px;
        width: ${LayoutConst.container.tablet}px;
        margin: 0 auto;
    }

    @media(max-width: 800px) {
        max-width: ${LayoutConst.container.s}px;
        width: ${LayoutConst.container.s}px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        padding: 0 16px;
    }
`;

/* та же шапка, но с отступами 24px — только для админки юнитов */
export const TeamsAdminHeader = styled(AdminHeader)`
    gap: 24px;
    margin-bottom: 24px;
`;

export const AdminHeaderWrapper = styled(FlexBox)`
    @media(max-width: ${LayoutConst.screen.s}px) {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }
`;

export const LongreadLinkWrapper = styled(FlexBox)`
    flex: 1 1 auto;
    position: relative;

    .not-allowed-text {
        position: absolute;
        bottom: -15px;
        width: 100%;
        color: red;
        font-size: 9px;
        line-height: 11px;
    }
    .loading-text{
        position: absolute;
        bottom: -15px;
        width: 100%;
        color: #BFBFBF;
        font-size: 9px;
        line-height: 11px;
    }

    input {
            width: 100%;
            margin-top: 8px;
            background: #F2F2F2;
            border: none;
            color: ${Colors.galBlack100};
            &::placeholder {
                color: #BFBFBF;
            }
            &:hover::placeholder {
                color: #BFBFBF;
            }
            &:focus::placeholder {
                color: #BFBFBF;
            }
        }
`

export const ProjectAvailableText = styled.span`
  color: rgba(144, 144, 144, 1);
`;

export const ProjectAvailableLink = styled.a`
  color: rgba(144, 144, 144, 1);
  cursor: pointer;
  margin-left: 4px;
`;

export const CompetenceResult = styled(FlexBox)`
    padding: 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    cursor: pointer;
    background-color: #f9f9f9;
`;
export const CompetenceItem = styled(FlexBox)`
    min-width: 127px;
    min-height: 30px;
    width: max-content;
    border: 1px solid #909090;
    border-radius: 5px;
    place-items: center;
    justify-content: center;
    position: relative;
    font-size: 15px;
    line-height: 20px;
    padding: 5px 16px;
    cursor: pointer;

    color: ${({ theme }) => theme.gridItem.color};

    svg {
        margin-left: 8px;
        cursor: pointer;
    }
`;
export const TeamAdminTitle = styled.h1`
    margin: 0px;
    font-size: 43px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px; /* 118.605% */
    letter-spacing: -0.86px;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
     @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; /* 133.333% */
        letter-spacing: -0.6px;
    }  
     @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 25px; /* 125% */
        letter-spacing: -0.4px;
    } 
`
export const SearchInputWrapper = styled(FlexBox)`
    max-width: 564px;
    box-sizing: border-box;
    & > div:hover, & > div:focus-within {
        border: 1px solid transparent !important;
    }
    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 100%;
    }
`;
export const JustTable = styled.table`
    border-collapse: collapse;
    width: 100%;
    font-size: 11px;
    line-height: 14px;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};

    th, td {
        text-align: left;
        padding: 12px 24px;
        height: 48px;
        font-size: 11px;
        line-height: 14px;
    }
    th {
        background-color: ${({ theme }) => theme.isDarkText ? '#151414' : Colors.zelWhite10};
        color: #ffffff;
    }
    td:last-child {
        text-align: right;
        font-size: 11px;
        font-weight: 400;
    }

    td:last-child > div > div,
    td:last-child [class*="BrgButton"],
    td:last-child button {
        font-size: 11px !important;
        font-weight: 400 !important;
    }

    tr:nth-child(even) {
        background-color: ${({ theme }) => theme.isDarkText ? '#f2f2f2' : Colors.zelWhite10};
        color: ${({ theme }) => theme.isDarkText ? '#000' : Colors.geoWhite100};
    }

    a {
        color: inherit;
    }

     @media(max-width: ${LayoutConst.screen.s}px) {
         padding: 8px 16px;
    }
`
export const TableScrollWrap = styled.div`
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }
`;

export const TableScrollBox = styled.div`
    width: 100%;
`;

export const TableScrollTrack = styled.div`
    width: 100%;
    height: 10px;
    margin-bottom: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    background: transparent;
    flex-shrink: 0;
    cursor: pointer;

    &::-webkit-scrollbar {
        height: 4px;
        cursor: pointer;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 2px;
        cursor: pointer;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 2px;
        cursor: pointer;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    > div {
        height: 1px;
    }
`;

export const Thead = styled.thead`
    th {
        background-color: ${({ theme }) => theme.isDarkText ? '#FFFFFF' : Colors.zelWhite5};
        color: ${({ theme }) => theme.isDarkText ? '#151514' : Colors.geoWhite100};
        border-bottom: 3px solid ${({ theme }) => theme.isDarkText ? '#000' : Colors.geoWhite47};
        font-size: 11px;
        line-height: 14px;
        font-weight: 400;
    }
`;
export const Button = styled.button`
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    color: #151514;

    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding: 0 48px;
    background: #FFFFFF;
    border-radius: 3px;
    border: 1px solid #909090;
    cursor: pointer;

    &:hover {
        border-color: #151514;
    }

    &:disabled {
        color: #909090;
        border-color: #d0d0d0;
        cursor: not-allowed;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        padding: 10px 24px;
        font-size: 15px;
        line-height: 20px;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
    }

`


export const ButtonsWrapper = styled.div<{ isBlackTheme?: boolean }>`
  position: relative;
  width: 100%;
  ${({ isBlackTheme }) => {
    // console.log(isBlackTheme)
    return isBlackTheme ? css`
    .hollow-button, .filled-button {
      color: #fefefe;
    }
  ` : null}};
`;

export const RowFlexContainer = styled(FlexBox)`
    flex-flow: row;
`;

export const CustomCheckboxContainer = styled(FlexBox)<{ disableMargin?: number }>`
    gap: 16px;
    > div {
        margin-right: 0px; 
    }

    ${({ disableMargin }) => disableMargin && css`
        * {
            margin-bottom: 0px;
        }
    `}

    @media(max-width: ${LayoutConst.screen.m}px) {
        > div {
            width: auto;
            max-width: 160px; 
            margin-bottom: 0;
        }
    }
`;

export const DeviderSubtitle = styled.div<{disableMargin?: boolean}>`
    width: 100%;
    margin-top: ${({ disableMargin }) => disableMargin ? 0 : 34}px;
    font-size: 30px;
    line-height: 40px;
    white-space: nowrap;
    color: ${Colors.galBlack100};
    font-weight: 600;

`;

export const SmallHeader = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    white-space: nowrap;
    color: ${Colors.galBlack47};
`;

export const SmallSubtitle = styled.div`
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: ${Colors.galBlack47};
`;

export const LiSubtitle = styled.li`
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: ${Colors.galBlack47};
    list-style-type: disc;
    padding-left: 0;
    margin-left: 0;
`;


export const GapContainer = styled(FlexBox)<{ gap?: number}>`
    gap: ${({ gap }) => gap || 8}px;
    flex-flow: column;

    ul {
        margin-bottom: 0px;
    }
`;

export const AdminPageFieldsSizeContainer = styled(FlexBox)`
    max-width: ${LayoutConst.adminPageContainer.default.l}px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        padding: 0 16px;
    }

    // @media (max-width: ${LayoutConst.screen.s - 1}px) {
    //     max-width: calc(100vw - 32px);
    // }


`;

export const AdminPageFieldsSizeContainerModal = styled(AdminPageFieldsSizeContainer)`
    max-width: ${LayoutConst.adminPageContainer.modal.l}px;
    flex-flow: column;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: calc(100vw - 20px);
        padding: 0px;
        margin: 0 auto;
    }
`

export const ProjectsSectionGap = styled(FlexBox).attrs({
    className:'sections-gap-container'
})<{ initialGap?: number }>`
    gap: ${({ initialGap }) => initialGap || 40}px;
    flex-flow: column;

    @media (max-width: ${LayoutConst.screen.m}px) {
        gap: 24px;
    }
`;

export const PeopleTabSectionGap = styled(ProjectsSectionGap)`
    width: 100%;
    min-width: 0;
    align-self: stretch;

    > * {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }

    .author-wrapper {
        width: 100%;
    }
`;

export const LimitContainer = styled(FlexBox)<{ initialGap?: number }>`
    gap: ${({ initialGap }) => initialGap || 40}px;
    flex-flow: column;

    @media (max-width: ${LayoutConst.screen.m}px) {
        gap: 24px;
    }
    max-width: calc(100% - ${EMBLEM_DESKTOP_SIZE.width}px - ${EMBLEM_DESKTOP_SIZE.gap}px);

    @media ${MEDIA.LAPTOP} {
        max-width: calc(100% - ${EMBLEM_LAPTOP_TABLET_SIZE.width}px - ${EMBLEM_LAPTOP_TABLET_SIZE.gap}px);
    }
    @media ${MEDIA.TABLET} {
        max-width: calc(100% - ${EMBLEM_TABLET_TABLET_SIZE.width}px - ${EMBLEM_TABLET_TABLET_SIZE.gap}px);
    }
    @media ${MEDIA.MOBILE} {
        max-width: calc(100% - ${EMBLEM_MOBILE_SIZE.width}px - ${EMBLEM_MOBILE_SIZE.gap}px);
    }
`;


export const TeamsTabsRow = styled(FlexBox)`
    flex-flow: column;
    align-items: flex-start;
    flex-wrap: nowrap;
    gap: 24px;
    width: 100%;

    /* цифровые представительства / организации — 17px */
    .teams-outer-inner-nav {
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.02em;
        &, * {
            font-size: 17px !important;
            line-height: 22px !important;
        }
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        gap: 16px;
    }
`;

export const AdminPageWrap = styled(FlexBox)`
    flex-flow: column;
    max-width: ${LayoutConst.container.l}px;
    width: 100%;
    margin: 0 auto;

    @media(max-width: ${LayoutConst.screen.m_1024}px) {
        padding: 0 10px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        max-width: ${LayoutConst.container.tablet}px;
        width: ${LayoutConst.container.tablet}px;
    }

    @media(max-width: 800px) {
        max-width: ${LayoutConst.container.s}px;
        width: ${LayoutConst.container.s}px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        max-width: 100%;
        // padding: 0 10px;
    }
`;

export const StatusFilterDropdownWrap = styled.div`
    min-width: 140px;
    width: 100%;
    font-size: 11px;
    line-height: 14px;
    font-weight: 400;
    font-family: inherit;

    .ui-input_container {
        width: 100%;
        min-width: 140px;
    }

    .brg-input__control {
        min-height: 40px !important;
        height: 40px !important;
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
        color: ${({ theme }) => theme.mainDropdownStyles?.colorActive ?? (theme.isDarkText ? '#151514' : Colors.geoWhite100)} !important;
        font-size: 11px !important;
        line-height: 14px !important;
        font-weight: 400 !important;
        font-family: inherit !important;
        cursor: pointer;
    }

    .brg-input__control--is-disabled {
        background-color: transparent !important;
        opacity: 1 !important;
        cursor: pointer;
    }

    .brg-input__control--menu-is-open {
        border: none !important;
        box-shadow: none !important;
    }

    .brg-input__value-container {
        padding: 0 4px 0 0 !important;
    }

    .brg-input__single-value {
        color: ${({ theme }) => theme.mainDropdownStyles?.colorActive ?? (theme.isDarkText ? '#151514' : Colors.geoWhite100)} !important;
        font-weight: 400 !important;
        font-size: 11px !important;
        line-height: 14px !important;
        font-family: inherit !important;
    }

    .brg-input__placeholder {
        color: ${({ theme }) => theme.mainDropdownStyles?.colorActive ?? (theme.isDarkText ? '#151514' : Colors.geoWhite100)} !important;
        font-size: 11px !important;
        line-height: 14px !important;
        font-weight: 400 !important;
        font-family: inherit !important;
    }

    .brg-input__indicator svg path {
        fill: ${({ theme }) => theme.mainDropdownStyles?.color ?? (theme.isDarkText ? '#909090' : Colors.geoWhite47)} !important;
    }

    .brg-input__menu {
        background-color: ${({ theme }) => theme.mainDropdownStyles?.bg ?? '#f2f2f2'} !important;
    }

    .brg-input__menu-list svg path,
    .brg-input__menu-list svg {
        fill: ${({ theme }) => theme.mainDropdownStyles?.color ?? '#151514'} !important;
    }

    .brg-input__option {
        color: ${({ theme }) => theme.mainDropdownStyles?.color ?? '#151514'} !important;
        background-color: transparent !important;
        font-size: 11px !important;
        line-height: 14px !important;
        font-weight: 400 !important;
        font-family: inherit !important;

        &:hover {
            background-color: ${({ theme }) => theme.mainDropdownStyles?.hoverBG ?? '#e7e7e7'} !important;
        }

        svg,
        svg path {
            fill: ${({ theme }) => theme.mainDropdownStyles?.color ?? '#151514'} !important;
        }
    }

    .brg-input__menu-list {
        color: ${({ theme }) => theme.mainDropdownStyles?.color ?? '#151514'};
        font-size: 11px;
        line-height: 14px;
        font-weight: 400;
        font-family: inherit;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: ${({ theme }) => theme.mainDropdownStyles?.bg ?? '#f2f2f2'};
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: ${({ theme }) => theme.mainDropdownStyles?.color ?? '#909090'};
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
            filter: brightness(0.85);
        }
    }
`;

export const GroupsContainer = styled(FlexBox)`
    flex-flow: column;
    gap: 16px 0px;

    .ui-input_container {
        min-width: 237px;
    }
`;

export const BigHeader = styled.div`
    font-weight: 600;
    font-size: 20px;
    line-height: 25px;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
`;

export const NewTable = styled.table<{ disabled?: boolean }>`
    border-collapse: collapse;
    width: 100%;

    th {
        background-color: transparent;
        color: ${({ theme }) => theme.isDarkText ? Colors.galBlack47 : Colors.geoWhite47};
        font-weight: 400;
        font-size: 15px;
        line-height: 20px;

        @media(max-width: ${LayoutConst.screen.md}px) {
            font-size: 13px;
            line-height: 16px;
        }
    }

    td:last-child {
        text-align: right;
    }

    td {
        color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
    }

    tr:nth-child(even) {
        background-color: ${Colors.galBlack5};
        td {
            color: ${Colors.galBlack100};
        }
    }

    ${({ disabled }) =>
            disabled && css`
            pointer-events: none;
            opacity: 0.9;
    `};

    th, td {
        text-align: left;
        padding: 8px 12px;

        @media(max-width: ${LayoutConst.screen.s}px) {
            padding: 8px 16px;
        }
    }

    td {
        height: 48px;
    }
`;

export const NewMobileTable = styled(FlexBox)`
    gap: 16px;
    flex-flow: column;
    width: 100%;
    min-width: calc(100vw - 20px);

    .ui-input_container {
        background-color: ${Colors.gal};
    }

`;

export const NewMobileTableItem = styled(FlexBox)`
    background-color: ${Colors.galBlack5};
    padding: 16px 10px;
    flex-flow: column;
    gap: 8px;
`;

export const NewMobileTableRow = styled(FlexBox)`
    flex-flow: column;
    gap: 8px;
    .label {
        font-size: 13px;
        line-height: 16px;
        color: ${Colors.galBlack47};
    }
`;

export const ServicesFieldsWrapper = styled(FlexBox)`
    flex-flow: column;
    gap: 32px;
`;

export const ServicesContentContainer = styled(FlexBox)`
    display: grid;
    grid-template-columns: 270px 1fr;
    gap: 24px;

    @media ${MEDIA.MOBILE} {
        grid-template-columns: 1fr;
    }
`;

export const ServiceInfoContainer = styled(FlexBox)`
    flex-flow: column;
    font-size: 15px;
    line-height: 20px;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack47 : Colors.geoWhite47};
    max-width: 886px;
    white-space: pre-line;
    p {
        margin: 0;
    }
`;

export const ServicesNavBarContainer = styled(FlexBox)`
    flex-flow: column;
    place-items: start;

    * {
        width: 100%;
    }
`;

export const ServicesNavBarItem = styled(FlexBox)<{ active?: boolean, disabled?: boolean }>`
    font-size: 20px;
    line-height: 25px;
    font-weight: 600;
    padding: 12px 16px 12px 0;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack47 : Colors.geoWhite47};
    cursor: pointer;
    border-bottom: 1px solid ${({ theme }) => theme.isDarkText ? Colors.galBlack47 : Colors.geoWhite47};
    &:hover {
        color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
    }
    ${({ active, theme }) => active && css`
        color: ${theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
        border-bottom: 1px solid ${theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
    `}

    ${({ disabled }) => disabled && css`
        pointer-events: none;
        opacity: 0.5;
    `}
`;

export const ServiceName = styled.div`
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
`;

export const ServiceLabel = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    font-family: 'Inter';
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack47 : Colors.geoWhite47};

    svg {
        width: 12px;
        height: 12px;
    }

    @media(${MEDIA.LAPTOP_STRONG}) {
        font-size: 13px;
        line-height: 16px;
    }
`

export const SwitchContainer = styled(FlexBox)<{switchValue?: number}>`
    width: 100%;
    flex-flow: row;
    justify-content: space-between;
    ${({ switchValue }) => switchValue === 1 && css`
        span:not(:last-child) {
            background-color: rgba(39, 174, 96, 1) !important;
        }
    `}
    ${({ switchValue }) => switchValue === 0 && css`
        span:not(:last-child) {
            background-color: ${Colors.galBlack47};
        }
    `}

    .input-span {
        color: ${Colors.galBlack47};
        font-size: 15px;
        line-height: 20px;
    }

`;

export const RowContainer = styled(FlexBox)`
    width: 100%;

    button {
        height: 48px;
        width: 241px;
        font-weight: 600;
        font-size: 17px;
        line-height: 22px;
        border-color: ${Colors.galBlack47} !important;
    }

    @media ${MEDIA.MOBILE} {
        flex-flow: column;
        gap: 16px;
    }


`

export const Devider = styled.div`
    height: 1px;
    background-color: ${Colors.galBlack47};
    // margin: 32px 0;
`;
import styled, { css } from "styled-components";
import { Colors, CommonLabel, FlexBox, GridBox, MEDIA } from '@brg/ui';
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { LayoutConst } from 'core';
import { ProjectEditPageGrid, ProjectEditPageGridLabel } from "shared/components/ProjectEditPageGrid";
import { EMBLEM_DESKTOP_SIZE, EMBLEM_TABLET_TABLET_SIZE, EMBLEM_MOBILE_SIZE, EMBLEM_LAPTOP_TABLET_SIZE } from "./const/emblemSizes";

export const CommonContainer = styled(ProjectEditPageGrid)<{ fullWidth?: boolean }>`
    max-width: ${({ fullWidth }) => fullWidth ? '1152px' : '804px'};
`;

export const ActionsButton = styled(FlexBox)`
    font-size: 11px;
    line-height: 13px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
    width: 107px;
    text-align: center;
    margin: 0 auto;
`;


export const TeamsWrapper = styled(FlexBox)`
    width: 100%;
    flex-flow: column;
    padding-top: 40px;
`;
export const TeamUploadText = styled.span`
    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 14px;
    }
`;

export const GridItem = styled(FlexBox)`
    min-width: 127px;
    min-height: 30px;
    max-width: 244px;
    border: 1px solid #909090;
    border-radius: 5px;
    place-items: center;
    justify-content: flex-start;
    position: relative;
    font-size: 15px;
    line-height: 20px;
    padding: 4px 15px 4px 16px;
    overflow: hidden;

    color: ${({ theme }) => theme.gridItem.color};

    .item-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0;
        max-width: calc(100% - 24px);
    }

    svg {
        margin-left: 8px;
        cursor: pointer;
        flex-shrink: 0;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px){
        min-width: 118px;
        min-height: 26px;
        font-size: 13px;
        line-height: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s-1}px){
        min-width: 110px;
        min-height: 26px;
    }
`;

export const Since = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    color: ${({ theme}) => theme.teamsPage.text.label.color};
`;

export const OwnerNamePrefix = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 32px;

    color: ${({ theme}) => theme.teamsPage.text.label.color};

`;

export const OwnerName = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 32px;
    color: ${({ theme}) => theme.teamsPage.text.color};
`;


export const AvatarWrapper = styled(FlexBox)`
    max-width: 270px;
    width: 270px;
    max-height: 183px;
`;

export const InfoWrapper = styled(FlexBox)`
    flex-flow: row;
    justify-content: space-between;
    place-items: start;
    width: calc(100% - 270px - 32px);
`;

export const ContentWrapper = styled(FlexBox)`
`;

export const LocationWrapper = styled(FlexBox)`
    height: 384px;
    max-heigt: 384px;
    width: 100%;
`;

export const DropdownWrapper = styled(FlexBox)`
    justify-content: flex-start;

    .dropdown-header {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 43px;
        line-height: 51px;
        letter-spacing: -0.02em;
        color: ${({ theme}) => theme.teamsPage.dropdown.text.color};
    }
`;

export const DescriptionWrapper = styled(FlexBox)`
    max-width: 688px;

    textarea {
        min-height: 163px !important;
        width: 688px;
        max-width: 688px;
        border: none;
        &::placeholder {
            color: ${p => p?.theme?.teamsPage.input.color};
        }
        &:hover {
            &::placeholder {
                color: ${p => p?.theme?.teamsPage.input.color};
            }
        }
    }
`;

export const TagsWrapper = styled(FlexBox)`
    max-width: 564px;
`;


export const PointLogoContainer = styled(FlexBox)`
    flex-flow: row;
`;

export const PointCity = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${({ theme}) => theme.teamsPage.text.color};
`;

export const PointText = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    margin: 0 8px 0 10.5px;
    color: ${({ theme}) => theme.teamsPage.text.point.color};
`;

export const TeamContextInputWrapper = styled(FlexBox)`
    // max-width: 600px !important;
    // width: 600px !important;
    width: 100%;
    flex-flow: row;

    .item-wrapper {
        margin: 0 8px 8px 0;
    }

    button {
        margin-left: 16px;
    }
    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 520px !important;
        width: 520px !important;
        
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
        width: 100% !important;
        max-width: 100% !important;
        
    }
`;

export const TeamContextListWrapper = styled(FlexBox)`
    max-width: 400px !important;
    width: 400px !important;
    flex-wrap: wrap;

    @media(max-width: ${LayoutConst.screen.s}px) {
        width: 100% !important;
        max-width: none !important;
    }
`;

export const TableSortWrapper = styled(FlexBox)<{backgroundColor?: string}>`

    .not-allowed-text {
        position: absolute;
        bottom: -15px;
        width: 100%;
        left: 32px;
        color: red;
        font-size: 9px;
        line-height: 11px;
    }
    position: relative;
    svg {
        margin-right: 8px;
    }

    input {
        // width: 394px;
        margin-right: 8px;
        background: ${({backgroundColor}) => backgroundColor ? backgroundColor + ' !important' : 'transparent'};
        &:disabled {
            color: ${({backgroundColor}) => backgroundColor ? '#ffffff !important' : '#909090'};
        }
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        input {
            width: 312px;
             margin-right: 0;
        }
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        input {
            width: 100%;
            min-width: 156px;
        }
    }
`;

export const TBody = styled.tbody<{ isFormEdit?: boolean }>`
    tr {
        width: ${({ isFormEdit }) => isFormEdit ? '185px' : '195px'};
        max-width: ${({ isFormEdit }) => isFormEdit ? '185px' : '195px'};

        ${ActionsButton} {
            width: 195px !important;
        }

        .brg-input__control {
            height: 48px !important;
        }

        td:first-child {
            padding-left: 0 !important;

            .brg-input__control {
                width: 195px !important;
            }
        }
    }

    .ui-input_container {
        width: 185px;
    }

    .anchor-info {
        width: ${({ isFormEdit }) => isFormEdit ? '185px' : '180px'} !important;
        text-align: center !important;
    }

    .brg-input__control {
        width: ${({ isFormEdit }) => isFormEdit ? '185px' : '195px'} !important;
        background-color: ${({ theme }) => theme.commonInput?.bg ?? '#f2f2f2'} !important;
        color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
        border: 0px solid transparent !important;
    }
    .brg-input__menu {
        background-color: ${({ theme }) => theme.commonInput?.bg ?? '#f2f2f2'} !important;
        * {
        color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
        background-color: transparent !important;
        cursor: pointer;
        }
    }
    .brg-input__single-value {
        color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
    }
    .brg-input__indicator {
        svg path {
            fill: ${({ theme }) => theme.commonInput?.icons?.color ?? '#909090'} !important;
        }
    }
`;
export const TBodyAdvertisements = styled.tbody`
    tr {
        .brg-input__control {
            height: 48px !important;
        }

        td:first-child {
            padding-left: 0 !important;

            .brg-input__control {
                width: 195px !important;
            }
        }
    }
`;

export const TeamsMobGridList = styled(GridBox)<{isTeamEditButtons?: boolean}>`
    gap: 16px;

    // input {
    //     max-width: 306.5px !important;
    //     height: 40px !important;
    //     @media(max-width: ${LayoutConst.screen.md}px){
    //         width: ${({isTeamEditButtons}) => isTeamEditButtons ? '260px' : '100%'} !important;
    //         max-width: 100% !important;
    //     }
    // }

${ProjectEditPageGridInput} {
    width: 306px !important;
    max-width: 306px !important;
    @media(max-width: ${LayoutConst.screen.md}px){
        width: ${({isTeamEditButtons}) => isTeamEditButtons ? 260 : 306}px !important;
    }

}

.brg-input__control {
    width: 306.5px !important;
    background-color: ${({ theme }) => theme.commonInput?.bg ?? '#f2f2f2'} !important;
    color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
    border: 0px solid transparent !important;
    height: 40px !important;
     @media(max-width: ${LayoutConst.screen.md}px){
            width: ${({isTeamEditButtons}) => isTeamEditButtons ? '260px' : '100%'} !important;
        }
}
.brg-input__menu {
    background-color: ${({ theme }) => theme.commonInput?.bg ?? '#f2f2f2'} !important;
    * {
    color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
    background-color: transparent !important;
    cursor: pointer;
    }
}
.brg-input__single-value {
    color: ${({ theme }) => theme.commonInput?.dropdown?.color ?? theme.commonInput?.color ?? '#909090'} !important;
}
.brg-input__indicator {
    svg path {
        fill: ${({ theme }) => theme.commonInput?.icons?.color ?? '#909090'} !important;
    }
}

@media(max-width: ${LayoutConst.screen.s}px) {
    grid-template-columns: 1fr !important;
    margin-left: 0 !important;

    ${ProjectEditPageGridInput} {
        width: 100% !important;
        max-width: 100% !important;
    }

    // input {
    //     max-width: 100% !important;
    //     height: 40px !important;
    //     background-color: #E7E7E7 !important;
    // }

    .brg-input__control {
        width: 100% !important;
        background-color: #E7E7E7 !important;
        color: #909090 !important;
        border: 0px solid transparent !important;
        height: 40px !important;
    }
}

`;

export const GridMobileNamed = styled(FlexBox)`
    flex-flow: row;
    width: 100%;
    place-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    span {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: #909090;
        margin-right: 24px;
        white-space: nowrap;
    }

    
    button {
        font-size: 13px !important;
        line-height: 16px !important;
    }
`;

export const TeamLgInputsWrapper = styled(FlexBox)<{ fs?: boolean, hide?: boolean }>`
    margin: ${({ fs }) => fs ? '0 auto 32px auto': '0 auto'};
    justify-content: flex-start;
    max-width: 1152px;
    width: 1152px;
    display: ${({ hide }) => hide ? 'none' : 'flex'};
`;

export const ColorWrapper = styled(FlexBox)`
    width: 602px;
`;

export const PlusButton = styled(FlexBox)`
    border-radius: 5px;
    border: 1px solid ${Colors.galBlack47};
    width: 48px;
    height: 30px;
    cursor: pointer;
    justify-content: center;
    place-items: center;
`;

export const InlinePlusButton = styled(PlusButton)`
    display: inline-block;
    text-align: center;
    vertical-align: middle;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 26px;
        width: 42px;
        svg {
            width: 12px;
            height: 12px;
        }
    }
`;

export const DefaultButton = styled.button<{ wh?: number, whMob?: number, whDes?: number, isTablet?: boolean, hollow?: boolean, isCompetitionEdit?: boolean, hasLongread?: boolean }>`
    display: flex;
    place-items: center;
    justify-content: center;
    height: 48px;
    border: 1px solid rgba(182, 182, 181, 1) !important;
    color: ${({ theme, hollow }) => hollow ? theme.competition.input.secondText : 'rgba(21, 21, 20, 1)'} !important;
    font-size: ${({ isCompetitionEdit }) => isCompetitionEdit ? '17px' : '15px'};
    font-family: 'Inter';
    line-height: ${({ isCompetitionEdit }) => isCompetitionEdit ? '22px' : '20px'};
    outline: none;
    cursor: pointer !important;
    border-radius: 3px;
    font-weight: ${({hasLongread}) => hasLongread ? 400 : 600};
    background-color: ${({ hollow }) => hollow ? 'transparent' : 'rgba(254, 254, 254, 1)'} !important;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        ${({ isCompetitionEdit }) => isCompetitionEdit && css`
            font-size: 15px;
            line-height: 20px;
        `};
        height: 40px;
        font-weight: 400;
    }

    &:disabled {
        pointer-events: none;
        background-color: transparent !important;
        cursor: not-allowed;
        color: grey !important;
        border: none;
    }

    svg {
        margin-right: 12px;

        path {
            fill: ${({ theme, hollow }) => hollow ? theme.competition.input.secondText : 'rgba(84, 84, 83, 1)'};
        }
    }

    ${({ wh }) => wh ? css`
        max-width: ${wh}px !important;
        width: ${wh}px !important;
        min-width: ${wh}px !important;
        background-color: rgba(254, 254, 254, 1);
    ` : null};

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        ${({ whDes }) => whDes ? css`
        max-width: ${whDes}px !important;
        width: ${whDes}px !important;
        min-width: ${whDes}px !important;
        background-color: rgba(254, 254, 254, 1);
    ` : null};
    }
    @media(max-width: ${LayoutConst.screen.md}px) {
        ${({ whMob }) => whMob ? css`
        max-width: ${whMob}px !important;
        width: ${whMob}px !important;
        min-width: ${whMob}px !important;
        background-color: rgba(254, 254, 254, 1);
    ` : null};
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: 100% !important;
        width: 100% !important;
        min-width: auto !important;
        background-color: rgba(254, 254, 254, 1);
    }
`;

export const UploaderWrapper = styled(FlexBox)<{ isUploaded?: boolean }>`
    max-width: 600px;
    width: 100%;
    position: relative;
    cursor: ${({ isUploaded }) => isUploaded ? 'default' : 'pointer'};

    .download-link {
        font-family: 'Inter';
        color: #151514 !important;
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        cursor: default !important;
    }

    a {
        color: #151514 !important;
        text-decoration: underline;
        cursor: pointer;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const MobileButtonsWrapper = styled(FlexBox)<{disabled?: boolean}>`

    @media(max-width: ${LayoutConst.screen.s}px) {
        background-color: #F2F2F2;
        border-radius: 3px;
        flex-flow: column;
        padding: 16px 10px;

        button {
            font-size: 13px !important;
            line-height: 16px !important;
        }
        ${({ disabled }) =>
            disabled && css`
            pointer-events: none;
            opacity: 0.6;
        `}
    }
`;

export const CoverWrapper = styled(FlexBox)`
    svg {
        &:hover {
            cursor: pointer;
        }
    }

    input[type='file'] {
        ::-webkit-file-upload-button { 
            cursor:pointer;
        }
        cursor: pointer;
        font-size: 0;
        position: absolute;
    }
`;

export const MainHeader = styled.h1`
    font-family: 'Inter';
    font-weight: 600;
    font-size: 60px;
    line-height: 70px;
    white-space: nowrap;
    // color: #151514;
    margin: 0;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 34px;
        line-height: 41px;
    }
    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 28px;
        line-height: 34px;
        white-space: pre;
    }
`;

export const ChannelMainHeader = styled(MainHeader)`
    font-size: 34px;
    line-height: 41px;
`;

export const ChannelDescription  = styled.div`
    font-family: 'Inter';
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #909090;
    margin: 0;
    max-width: 802px;

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

export const OuterDescription = styled(ChannelDescription)<{darkText?: boolean }>`
    color: ${({ darkText }) => darkText ? Colors.galBlack100 : Colors.galBlack47};

    a {
    text-decoration: underline;
    }
`

export const SuccessMsg = styled.div`
    font-family: 'Inter';
    font-weight: 600;
    font-size: 34px;
    line-height: 41px;
    color: #151514;
    margin-top: 15px;
    max-width: 700px;
    text-align: center;

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        white-space: pre-wrap;
        font-size: 20px;
        line-height: 32px;
    }
`;

export const MainTabsWrapper = styled(FlexBox)`
    flex-flow: row;

    .white_theme_project_underline {
        font-size: 23px;
        line-height: 29px;
        margin-right: 40px;

        @media(max-width: ${LayoutConst.screen.m}px) {
            font-size: 17px;
            line-height: 22px;
            margin-right: 24px;
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 13px;
            line-height: 18px;
        }
    }
`;

export const MainFilterContainer = styled(CommonContainer)<{isShopTagsOnly?: boolean}>`
    .checkbox {
        padding-bottom: 0;
        padding-top: 0;
    }
     @media(max-width: ${LayoutConst.screen.md}px) {
        margin: ${({isShopTagsOnly}) => isShopTagsOnly ? '15px 0px' : '15px 20px'};
     }    
     @media(max-width: ${LayoutConst.screen.s}px) {
        margin: 0 auto;
        margin-top: 24px;
     }    
`;

export const LangBlockWrapper = styled(FlexBox)<{ maxSize?: number }>`
    // flex-flow: row;
    align-items: start;
    max-width: ${({ maxSize }) => maxSize ? maxSize : 802}px;
    // margin-top: 40px;
    width: 100%;

    input, textarea {
        margin: 0;
    }

    .styled-input {
        width:100% !important;
    }

    th {
        padding-top: 0 !important;
    }

    .lang-label-block {
        margin-right: 32px !important;
        width: 180px;
        min-width: 180px;
        justify-content: space-between;
        .lang-label {
            width: auto;
        }

        h6 {
            font-size: 17px;
            line-height: 22px;
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px){
            width: 100%;
            min-width: 100%;
        }
    }
    @media(max-width: ${LayoutConst.screen.m}px){
        max-width: 720px;
    }
`;

export const LangBlockWrapperWithInfoMargin = styled(LangBlockWrapper)`
    .info-icon-wrapper {
        margin-right: 0;
    }
`;


export const TeamEditLabel = styled(ProjectEditPageGridLabel)<{ required?: boolean, nowrap?: boolean, fullWidth?: boolean}>`
    width: ${({ fullWidth }) => fullWidth ? '100%' : '180px'};
    min-width: ${({ fullWidth }) => fullWidth ? '100%' : '180px'};
    max-width: ${({ fullWidth }) => fullWidth ? '100%' : '180px'};
    margin-right: 32px;
    // align-items: flex-start;
    padding-top: 0;

    font-size: 15px;
    line-height: 20px;
    position: relative;

    ${({ required }) => required && css`
        &::after {
            position: absolute;
            top: 3px;
            right: -8px;
            content: '*';
            display: contents;
            color: #C64839;
        }
    }
    `};

    .required-label {
        &::after {
            position: absolute;
            top: 50%;
            left: 10%;
            transform: translateY(-50%);
            display: contents;
            content: '*';
            color: #C64839;
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        width: ${({ fullWidth }) => fullWidth ? '100%' : '180px'};
        min-width: ${({ fullWidth }) => fullWidth ? '100%' : '180px'};
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        white-space: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'}!important;
    }

    @media(max-width: ${LayoutConst.screen.s-1}px) {
        width: 100%;
        max-width: none;
        white-space: pre-wrap !important;
        font-size: 15px;
        line-height: 20px;
        .required-label {
            position: relative;
            &::after {
                position: absolute;
                top: 50%;
                left: 102%;
                display: inline;
                content: '*';
            }
    }
    }
`;

export const AdminHeader = styled(FlexBox)`
    flex-flow: column;
    gap: 32px;
    margin-bottom: 32px;

    @media(max-width: ${LayoutConst.screen.m_1024}px) {
        margin: 0 10px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        max-width: ${LayoutConst.container.tablet}px;
        width: ${LayoutConst.container.tablet}px;
        margin: 0 auto;
    }

    @media(max-width: 800px) {
        max-width: ${LayoutConst.container.s}px;
        width: ${LayoutConst.container.s}px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        padding: 0 16px;
    }
`;

/* та же шапка, но с отступами 24px — только для админки юнитов */
export const TeamsAdminHeader = styled(AdminHeader)`
    gap: 24px;
    margin-bottom: 24px;
`;

export const AdminHeaderWrapper = styled(FlexBox)`
    @media(max-width: ${LayoutConst.screen.s}px) {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }
`;

export const LongreadLinkWrapper = styled(FlexBox)`
    flex: 1 1 auto;
    position: relative;

    .not-allowed-text {
        position: absolute;
        bottom: -15px;
        width: 100%;
        color: red;
        font-size: 9px;
        line-height: 11px;
    }
    .loading-text{
        position: absolute;
        bottom: -15px;
        width: 100%;
        color: #BFBFBF;
        font-size: 9px;
        line-height: 11px;
    }

    input {
            width: 100%;
            margin-top: 8px;
            background: #F2F2F2;
            border: none;
            color: ${Colors.galBlack100};
            &::placeholder {
                color: #BFBFBF;
            }
            &:hover::placeholder {
                color: #BFBFBF;
            }
            &:focus::placeholder {
                color: #BFBFBF;
            }
        }
`

export const ProjectAvailableText = styled.span`
  color: rgba(144, 144, 144, 1);
`;

export const ProjectAvailableLink = styled.a`
  color: rgba(144, 144, 144, 1);
  cursor: pointer;
  margin-left: 4px;
`;

export const CompetenceResult = styled(FlexBox)`
    padding: 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    cursor: pointer;
    background-color: #f9f9f9;
`;
export const CompetenceItem = styled(FlexBox)`
    min-width: 127px;
    min-height: 30px;
    width: max-content;
    border: 1px solid #909090;
    border-radius: 5px;
    place-items: center;
    justify-content: center;
    position: relative;
    font-size: 15px;
    line-height: 20px;
    padding: 5px 16px;
    cursor: pointer;

    color: ${({ theme }) => theme.gridItem.color};

    svg {
        margin-left: 8px;
        cursor: pointer;
    }
`;
export const TeamAdminTitle = styled.h1`
    margin: 0px;
    font-size: 43px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px; /* 118.605% */
    letter-spacing: -0.86px;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
     @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; /* 133.333% */
        letter-spacing: -0.6px;
    }  
     @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 25px; /* 125% */
        letter-spacing: -0.4px;
    } 
`
export const SearchInputWrapper = styled(FlexBox)`
    max-width: 564px;
    box-sizing: border-box;
    & > div:hover, & > div:focus-within {
        border: 1px solid transparent !important;
    }
    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 100%;
    }
`;
export const JustTable = styled.table`
    border-collapse: collapse;
    width: 100%;
    font-size: 11px;
    line-height: 14px;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};

    th, td {
        text-align: left;
        padding: 12px 24px;
        height: 48px;
        font-size: 11px;
        line-height: 14px;
    }
    th {
        background-color: ${({ theme }) => theme.isDarkText ? '#151414' : Colors.zelWhite10};
        color: #ffffff;
    }
    td:last-child {
        text-align: right;
        font-size: 11px;
        font-weight: 400;
    }

    td:last-child > div > div,
    td:last-child [class*="BrgButton"],
    td:last-child button {
        font-size: 11px !important;
        font-weight: 400 !important;
    }

    tr:nth-child(even) {
        background-color: ${({ theme }) => theme.isDarkText ? '#f2f2f2' : Colors.zelWhite10};
        color: ${({ theme }) => theme.isDarkText ? '#000' : Colors.geoWhite100};
    }

    a {
        color: inherit;
    }

     @media(max-width: ${LayoutConst.screen.s}px) {
         padding: 8px 16px;
    }
`
export const TableScrollWrap = styled.div`
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }
`;

export const TableScrollBox = styled.div`
    width: 100%;
`;

export const TableScrollTrack = styled.div`
    width: 100%;
    height: 10px;
    margin-bottom: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    background: transparent;
    flex-shrink: 0;
    cursor: pointer;

    &::-webkit-scrollbar {
        height: 4px;
        cursor: pointer;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 2px;
        cursor: pointer;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 2px;
        cursor: pointer;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    > div {
        height: 1px;
    }
`;

export const Thead = styled.thead`
    th {
        background-color: ${({ theme }) => theme.isDarkText ? '#FFFFFF' : Colors.zelWhite5};
        color: ${({ theme }) => theme.isDarkText ? '#151514' : Colors.geoWhite100};
        border-bottom: 3px solid ${({ theme }) => theme.isDarkText ? '#000' : Colors.geoWhite47};
        font-size: 11px;
        line-height: 14px;
        font-weight: 400;
    }
`;
export const Button = styled.button`
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    color: #151514;

    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding: 0 48px;
    background: #FFFFFF;
    border-radius: 3px;
    border: 1px solid #909090;
    cursor: pointer;

    &:hover {
        border-color: #151514;
    }

    &:disabled {
        color: #909090;
        border-color: #d0d0d0;
        cursor: not-allowed;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        padding: 10px 24px;
        font-size: 15px;
        line-height: 20px;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
    }

`


export const ButtonsWrapper = styled.div<{ isBlackTheme?: boolean }>`
  position: relative;
  width: 100%;
  ${({ isBlackTheme }) => {
    // console.log(isBlackTheme)
    return isBlackTheme ? css`
    .hollow-button, .filled-button {
      color: #fefefe;
    }
  ` : null}};
`;

export const RowFlexContainer = styled(FlexBox)`
    flex-flow: row;
`;

export const CustomCheckboxContainer = styled(FlexBox)<{ disableMargin?: number }>`
    gap: 16px;
    > div {
        margin-right: 0px; 
    }

    ${({ disableMargin }) => disableMargin && css`
        * {
            margin-bottom: 0px;
        }
    `}

    @media(max-width: ${LayoutConst.screen.m}px) {
        > div {
            width: auto;
            max-width: 160px; 
            margin-bottom: 0;
        }
    }
`;

export const DeviderSubtitle = styled.div<{disableMargin?: boolean}>`
    width: 100%;
    margin-top: ${({ disableMargin }) => disableMargin ? 0 : 34}px;
    font-size: 30px;
    line-height: 40px;
    white-space: nowrap;
    color: ${Colors.galBlack100};
    font-weight: 600;

`;

export const SmallHeader = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    white-space: nowrap;
    color: ${Colors.galBlack47};
`;

export const SmallSubtitle = styled.div`
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: ${Colors.galBlack47};
`;

export const LiSubtitle = styled.li`
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: ${Colors.galBlack47};
    list-style-type: disc;
    padding-left: 0;
    margin-left: 0;
`;


export const GapContainer = styled(FlexBox)<{ gap?: number}>`
    gap: ${({ gap }) => gap || 8}px;
    flex-flow: column;

    ul {
        margin-bottom: 0px;
    }
`;

export const AdminPageFieldsSizeContainer = styled(FlexBox)`
    max-width: ${LayoutConst.adminPageContainer.default.l}px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        padding: 0 16px;
    }

    // @media (max-width: ${LayoutConst.screen.s - 1}px) {
    //     max-width: calc(100vw - 32px);
    // }


`;

export const AdminPageFieldsSizeContainerModal = styled(AdminPageFieldsSizeContainer)`
    max-width: ${LayoutConst.adminPageContainer.modal.l}px;
    flex-flow: column;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: calc(100vw - 20px);
        padding: 0px;
        margin: 0 auto;
    }
`

export const ProjectsSectionGap = styled(FlexBox).attrs({
    className:'sections-gap-container'
})<{ initialGap?: number }>`
    gap: ${({ initialGap }) => initialGap || 40}px;
    flex-flow: column;

    @media (max-width: ${LayoutConst.screen.m}px) {
        gap: 24px;
    }
`;

export const PeopleTabSectionGap = styled(ProjectsSectionGap)`
    width: 100%;
    min-width: 0;
    align-self: stretch;

    > * {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }

    .author-wrapper {
        width: 100%;
    }
`;

export const LimitContainer = styled(FlexBox)<{ initialGap?: number }>`
    gap: ${({ initialGap }) => initialGap || 40}px;
    flex-flow: column;

    @media (max-width: ${LayoutConst.screen.m}px) {
        gap: 24px;
    }
    max-width: calc(100% - ${EMBLEM_DESKTOP_SIZE.width}px - ${EMBLEM_DESKTOP_SIZE.gap}px);

    @media ${MEDIA.LAPTOP} {
        max-width: calc(100% - ${EMBLEM_LAPTOP_TABLET_SIZE.width}px - ${EMBLEM_LAPTOP_TABLET_SIZE.gap}px);
    }
    @media ${MEDIA.TABLET} {
        max-width: calc(100% - ${EMBLEM_TABLET_TABLET_SIZE.width}px - ${EMBLEM_TABLET_TABLET_SIZE.gap}px);
    }
    @media ${MEDIA.MOBILE} {
        max-width: calc(100% - ${EMBLEM_MOBILE_SIZE.width}px - ${EMBLEM_MOBILE_SIZE.gap}px);
    }
`;


export const TeamsTabsRow = styled(FlexBox)`
    flex-flow: column;
    align-items: flex-start;
    flex-wrap: nowrap;
    gap: 24px;
    width: 100%;

    /* цифровые представительства / организации — 17px */
    .teams-outer-inner-nav {
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.02em;
        &, * {
            font-size: 17px !important;
            line-height: 22px !important;
        }
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        gap: 16px;
    }
`;

export const AdminPageWrap = styled(FlexBox)`
    flex-flow: column;
    max-width: ${LayoutConst.container.l}px;
    width: 100%;
    margin: 0 auto;

    @media(max-width: ${LayoutConst.screen.m_1024}px) {
        padding: 0 10px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        max-width: ${LayoutConst.container.tablet}px;
        width: ${LayoutConst.container.tablet}px;
    }

    @media(max-width: 800px) {
        max-width: ${LayoutConst.container.s}px;
        width: ${LayoutConst.container.s}px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        max-width: 100%;
        // padding: 0 10px;
    }
`;

export const StatusFilterDropdownWrap = styled.div`
    min-width: 140px;
    width: 100%;
    font-size: 11px;
    line-height: 14px;
    font-weight: 400;
    font-family: inherit;

    .ui-input_container {
        width: 100%;
        min-width: 140px;
    }

    .brg-input__control {
        min-height: 40px !important;
        height: 40px !important;
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
        color: ${({ theme }) => theme.mainDropdownStyles?.colorActive ?? (theme.isDarkText ? '#151514' : Colors.geoWhite100)} !important;
        font-size: 11px !important;
        line-height: 14px !important;
        font-weight: 400 !important;
        font-family: inherit !important;
        cursor: pointer;
    }

    .brg-input__control--is-disabled {
        background-color: transparent !important;
        opacity: 1 !important;
        cursor: pointer;
    }

    .brg-input__control--menu-is-open {
        border: none !important;
        box-shadow: none !important;
    }

    .brg-input__value-container {
        padding: 0 4px 0 0 !important;
    }

    .brg-input__single-value {
        color: ${({ theme }) => theme.mainDropdownStyles?.colorActive ?? (theme.isDarkText ? '#151514' : Colors.geoWhite100)} !important;
        font-weight: 400 !important;
        font-size: 11px !important;
        line-height: 14px !important;
        font-family: inherit !important;
    }

    .brg-input__placeholder {
        color: ${({ theme }) => theme.mainDropdownStyles?.colorActive ?? (theme.isDarkText ? '#151514' : Colors.geoWhite100)} !important;
        font-size: 11px !important;
        line-height: 14px !important;
        font-weight: 400 !important;
        font-family: inherit !important;
    }

    .brg-input__indicator svg path {
        fill: ${({ theme }) => theme.mainDropdownStyles?.color ?? (theme.isDarkText ? '#909090' : Colors.geoWhite47)} !important;
    }

    .brg-input__menu {
        background-color: ${({ theme }) => theme.mainDropdownStyles?.bg ?? '#f2f2f2'} !important;
    }

    .brg-input__menu-list svg path,
    .brg-input__menu-list svg {
        fill: ${({ theme }) => theme.mainDropdownStyles?.color ?? '#151514'} !important;
    }

    .brg-input__option {
        color: ${({ theme }) => theme.mainDropdownStyles?.color ?? '#151514'} !important;
        background-color: transparent !important;
        font-size: 11px !important;
        line-height: 14px !important;
        font-weight: 400 !important;
        font-family: inherit !important;

        &:hover {
            background-color: ${({ theme }) => theme.mainDropdownStyles?.hoverBG ?? '#e7e7e7'} !important;
        }

        svg,
        svg path {
            fill: ${({ theme }) => theme.mainDropdownStyles?.color ?? '#151514'} !important;
        }
    }

    .brg-input__menu-list {
        color: ${({ theme }) => theme.mainDropdownStyles?.color ?? '#151514'};
        font-size: 11px;
        line-height: 14px;
        font-weight: 400;
        font-family: inherit;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: ${({ theme }) => theme.mainDropdownStyles?.bg ?? '#f2f2f2'};
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: ${({ theme }) => theme.mainDropdownStyles?.color ?? '#909090'};
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
            filter: brightness(0.85);
        }
    }
`;

export const GroupsContainer = styled(FlexBox)`
    flex-flow: column;
    gap: 16px 0px;

    .ui-input_container {
        min-width: 237px;
    }
`;

export const BigHeader = styled.div`
    font-weight: 600;
    font-size: 20px;
    line-height: 25px;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
`;

export const NewTable = styled.table<{ disabled?: boolean }>`
    border-collapse: collapse;
    width: 100%;

    th {
        background-color: transparent;
        color: ${({ theme }) => theme.isDarkText ? Colors.galBlack47 : Colors.geoWhite47};
        font-weight: 400;
        font-size: 15px;
        line-height: 20px;

        @media(max-width: ${LayoutConst.screen.md}px) {
            font-size: 13px;
            line-height: 16px;
        }
    }

    td:last-child {
        text-align: right;
    }

    td {
        color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
    }

    tr:nth-child(even) {
        background-color: ${Colors.galBlack5};
        td {
            color: ${Colors.galBlack100};
        }
    }

    ${({ disabled }) =>
            disabled && css`
            pointer-events: none;
            opacity: 0.9;
    `};

    th, td {
        text-align: left;
        padding: 8px 12px;

        @media(max-width: ${LayoutConst.screen.s}px) {
            padding: 8px 16px;
        }
    }

    td {
        height: 48px;
    }
`;

export const NewMobileTable = styled(FlexBox)`
    gap: 16px;
    flex-flow: column;
    width: 100%;
    min-width: calc(100vw - 20px);

    .ui-input_container {
        background-color: ${Colors.gal};
    }

`;

export const NewMobileTableItem = styled(FlexBox)`
    background-color: ${Colors.galBlack5};
    padding: 16px 10px;
    flex-flow: column;
    gap: 8px;
`;

export const NewMobileTableRow = styled(FlexBox)`
    flex-flow: column;
    gap: 8px;
    .label {
        font-size: 13px;
        line-height: 16px;
        color: ${Colors.galBlack47};
    }
`;

export const ServicesFieldsWrapper = styled(FlexBox)`
    flex-flow: column;
    gap: 32px;
`;

export const ServicesContentContainer = styled(FlexBox)`
    display: grid;
    grid-template-columns: 270px 1fr;
    gap: 24px;

    @media ${MEDIA.MOBILE} {
        grid-template-columns: 1fr;
    }
`;

export const ServiceInfoContainer = styled(FlexBox)`
    flex-flow: column;
    font-size: 15px;
    line-height: 20px;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack47 : Colors.geoWhite47};
    max-width: 886px;
    white-space: pre-line;
    p {
        margin: 0;
    }
`;

export const ServicesNavBarContainer = styled(FlexBox)`
    flex-flow: column;
    place-items: start;

    * {
        width: 100%;
    }
`;

export const ServicesNavBarItem = styled(FlexBox)<{ active?: boolean, disabled?: boolean }>`
    font-size: 20px;
    line-height: 25px;
    font-weight: 600;
    padding: 12px 16px 12px 0;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack47 : Colors.geoWhite47};
    cursor: pointer;
    border-bottom: 1px solid ${({ theme }) => theme.isDarkText ? Colors.galBlack47 : Colors.geoWhite47};
    &:hover {
        color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
    }
    ${({ active, theme }) => active && css`
        color: ${theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
        border-bottom: 1px solid ${theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
    `}

    ${({ disabled }) => disabled && css`
        pointer-events: none;
        opacity: 0.5;
    `}
`;

export const ServiceName = styled.div`
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack100 : Colors.geoWhite100};
`;

export const ServiceLabel = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    font-family: 'Inter';
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.isDarkText ? Colors.galBlack47 : Colors.geoWhite47};

    svg {
        width: 12px;
        height: 12px;
    }

    @media(${MEDIA.LAPTOP_STRONG}) {
        font-size: 13px;
        line-height: 16px;
    }
`

export const SwitchContainer = styled(FlexBox)<{switchValue?: number}>`
    width: 100%;
    flex-flow: row;
    justify-content: space-between;
    ${({ switchValue }) => switchValue === 1 && css`
        span:not(:last-child) {
            background-color: rgba(39, 174, 96, 1) !important;
        }
    `}
    ${({ switchValue }) => switchValue === 0 && css`
        span:not(:last-child) {
            background-color: ${Colors.galBlack47};
        }
    `}

    .input-span {
        color: ${Colors.galBlack47};
        font-size: 15px;
        line-height: 20px;
    }

`;

export const RowContainer = styled(FlexBox)`
    width: 100%;

    button {
        height: 48px;
        width: 241px;
        font-weight: 600;
        font-size: 17px;
        line-height: 22px;
        border-color: ${Colors.galBlack47} !important;
    }

    @media ${MEDIA.MOBILE} {
        flex-flow: column;
        gap: 16px;
    }


`

export const Devider = styled.div`
    height: 1px;
    background-color: ${Colors.galBlack47};
    // margin: 32px 0;
`;
